module.exports = __webpack_public_path__ + "img/Life-Insurance-Guide_Products_Annuities-Icon.483d19d3.svg";